/**
 * Its Types, Interfaces (e.g. enums)
 */
import { RouteComponentProps } from 'react-router-dom';
import * as React from 'react';


export interface IAppPropsWithRoute extends RouteComponentProps<any>, React.Props<any>
{
};


export enum TransferEstimateTaskType {
    EnRouteToPickup = 3,
    PickingUp = 7,
    EnRouteToDestination = 8,
    DropingOff = 9,
    Complete = 4
}

export interface ITextInputConfig {
    placeholder: string,
   
    id?: string,
    type?: string,
    disabled?: boolean,
    defaultValue?: string,
    required?: boolean,
    inputProps?: any,
    autoComplete?: string
};

export interface ITextInputProps extends React.Props<any> {
    elementConfig: ITextInputConfig,
    extClasses?: any,
    value?: any,
    changed(e: React.ChangeEvent<HTMLInputElement>): void,
    invalid?: boolean,
    shouldValidate?: boolean,
    touched?: boolean,
    variant: "primary" | "secondary",
    showPasswordAdornment?: boolean
};

export interface ITransferTasksEstimate {
    transferTasksEstimateId: string | null,
    virtualTripId: string | null,
    transferId: string,
    type: TransferEstimateTaskType,
    duration: number,
    startDateTime: string,
    customerLocationtimezone: string,
    endDateTime: string,
    sequence: number | null
}

export interface IAppModal {
    message?: string,
    title?: string,
    isAppModalOpened: boolean
};

export interface IBookingSpecialNeed {
    bookingSpecialNeedId: string,
    specialNeedId: string,
    specialNeedName: string,
    specialNeedIconUrl: string
}

export interface ISchedule {
    isAdhocRequested: boolean | null;
    isPlannerDraggable: boolean | null;
    isPlannerScheduled: boolean | null;
    delayed: boolean | null;
    delay: any;
    mins: any;
    kms: any;
    destCustLocationLongitude: number | null;
    destCustLocationLatitude: number | null;
    originCustLocationLongitude: number | null;
    originCustLocationLatitude: number | null;
    bearingAngle: number | null;
    transferId: string,
    bookingId: string,
    bookingNumber: number,
    createdOn: Date,
    modifiedOn: Date,
    firstName: string,
    lastName: string,
    originLocationName: string,
    originLocationShortName: string,
    originCustomerLocationId: string,
    originCustLocationGeoName: string,
    destinationCustomerLocationId: string,
    destinationLocationName: string,
    destinationGooglePlaceId: string,
    originWardName: string,
    originName: string,
    originGooglePlaceId: string,
    destinationLocationShortName: string | null,
    destinationCustLocationGeoName: string,
    originLatitude: number | null,
    originLongitude: number | null,
    destinationLatitude: number | null,
    destinationLongitude: number | null,
    destinationWardName: string,
    destinationName: string,
    priority?: number
    status: number,
    originBed: string,
    destinationBed: string,
    destinationWardId?: string | null,
    originWardId?: string | null,
    assignedVehicle: boolean | null,
    assignedToMe: boolean | null,

    patientOfLocation: string | null,
    originStreetAddress: string,
    originSuburb: string,
    originState: string,
    destinationStreetAddress: string,
    destinationSuburb: string,
    destinationState: string,

    anyTimeOfTheDay?: boolean,
    pickupBeforeTime?: any,
    pickupAfterTime?: any,
    dropoffBeforeTime?: any,
    dropoffAfterTime?: any,
    scheduledDate?: string | null,
    reasonForThisTime?: any,
    otherReasonDetails?: string | null,
    bookingDate?: any,
    pickupActualTime?: any, 
    pickUpDateTime?: any,

    bookingSpecialNeeds: IBookingSpecialNeed[],
    mobility:number,
    classification: number,
    canBeScheduledByCurrentUser: boolean,
    canBeEditedByCurrentUser: boolean,
    canBeCancelledByCurrentUser: boolean,
    tripPlannerId: string | null,
    estimatedDurationInMunutes: number | null,
    virtualTripSequence: number | null,
    virtualTripId: string | null,
    firstInMultiLoad?: boolean,
    lastInMultiLoad?: boolean,
    middleInMultiLoad?: boolean,
    existsPlannerForLocation: boolean,
    transferTaskEstimates?: ITransferTasksEstimate[] | null,
    ownerLocation: string,
    customerLocationtimezone : string,
    fleet : string | null,
    cancellationTime:string|null,
    cancellationNoticePeriod:string|null,
    reasonForCancellation:string|null,
    reasonForCancellationNote:string|null,
    timezone:string|null,
    billingType:string|null,
    billingChargeValue:string|null,
    billingSubTotals:string|null,
    discountValue:string|null,
    netTransferFee:string|null,
    isTripMinOverrided?: boolean,
    overrideTripEstimateInMin: number | 0


};

export interface IVehicleLocation{
    latitude: number,
    linearDistance?: number,
    longitude: number,
    objectNo?: string,
    objectState?: number,
    objectUid?: string,
    routeDistance?: number,
    routeTime?: number,
    color?: string
};


interface IGraphStats {
    description: null | string,
    name: null | string,
    recordCount: number,
    recordCountDaily: null | number,
    recordPercentage: null | number,
}

export interface IReasonForDelayData extends IGraphStats {}

export interface ITransportByWardData extends IGraphStats {}

export interface ITopFiveDestinationsData extends IGraphStats {}

export interface ITransportByDayOfWeek extends IGraphStats {}

export interface ITransportTimeByDayData extends IGraphStats {
    Weekday: string | null
}

export interface ITransFersPerformedData {
    aborted: number,
    name: string
    pickUpDelayed: number,
    recordCount: number,
    transferDelayed: number,
    date: string
}

export interface ITransFersPerformedDataCvt {
    "Total transfers": number;
    "Pickup time delayed": number;
    "Transfers delayed": number;
    "Aborted": number;
    "name": string;
    "date": string;
}
export enum PermissionType {
    Read = 0,
    Create,
    Edit,
    Delete
}
export enum PermissionAccessLevel {
    None = 0,
    Ward,
    Location,
    Global
}
export interface UserPermission {
    Action: PermissionType,
    AccessLevel: PermissionAccessLevel,
    Table: string
}
export enum PCRReviewStatus {
        All=-1,
        NotApplicable = 0,
        ReviewPending = 1,
        InReview = 2,
        Reviewed = 3,
        Flagged = 4,
        PendingCGReview = 5,
        InCGReview = 6,
        CGReviewed = 7,
        CGFlagged = 8,
}